// Must match verificationMissing on the server (profileComplete.js): personal info and a profile photo.
// The gallery isn't asked for verification (her call 10/31); it only counts toward a complete profile.
const VER_REQUIRED = ['firstName', 'lastName', 'birthday', 'gender', 'email', 'phone'];

const filled = (v) => String(v ?? '').trim() !== '';

export function verificationMissing(user) {
    if (!user) return [];
    return [
        ...VER_REQUIRED.filter((k) => !filled(user[k])),
        // photo_url, not the stored key: it's what the page shows to compare, and a takedown clears it.
        ...(!filled(user.photo_url) ? ['profile photo'] : []),
    ];
}
